module.exports = "<svg preserveAspectRatio=\"none\" viewBox=\"0 0 798.2 543.3\"><path d=\"M798.2 52.8L0 0v543.3l683.1-54.1z\" class=\"st61\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/skew-box-page.svg
// module id = 317
// module chunks = 1